export const formatOrderNotes = (notes) => {
    if (!notes) return '';
    let formattedNotes = notes;
    
    // Match old format with COP or new format without COP
    const splitRegexLegacy = /\[SPLIT\] CASH_USD=([\d.]+) CASH_COP=([\d.]+) TRANSFER_USD=([\d.]+) TRANSFER_COP=([\d.]+)/;
    const splitRegexNew = /\[SPLIT\] CASH_USD=([\d.]+) TRANSFER_USD=([\d.]+)/;
    
    const matchLegacy = formattedNotes.match(splitRegexLegacy);
    const matchNew = formattedNotes.match(splitRegexNew);
    
    if (matchLegacy || matchNew) {
        let cashUsd = 0;
        let transUsd = 0;
        
        if (matchLegacy) {
            cashUsd = parseFloat(matchLegacy[1]);
            transUsd = parseFloat(matchLegacy[3]);
        } else if (matchNew) {
            cashUsd = parseFloat(matchNew[1]);
            transUsd = parseFloat(matchNew[2]);
        }
        
        let splitDetails = [];
        if (cashUsd > 0) splitDetails.push(`Efec: $${cashUsd.toFixed(2)}`);
        if (transUsd > 0) splitDetails.push(`Trans: $${transUsd.toFixed(2)}`);
        
        let readableSplit = 'Pago Dividido';
        if (splitDetails.length > 0) {
            readableSplit += ` (${splitDetails.join(' | ')})`;
        }
        
        if (matchLegacy) {
            formattedNotes = formattedNotes.replace(splitRegexLegacy, readableSplit);
        } else if (matchNew) {
            formattedNotes = formattedNotes.replace(splitRegexNew, readableSplit);
        }
    }
    
    // Clean up any stray pipes that might have been left if notes was only the [SPLIT] text
    formattedNotes = formattedNotes.replace(/^[\s|]+|[\s|]+$/g, '');
    
    return formattedNotes;
};
